import { createVNode as a, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileJpegTwotoneStandard.js";
import p from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return a(p, n(r, {
    icon: i
  }), null);
};
e.displayName = "FileJpegTwotoneStandard";
e.inheritAttrs = !1;
export {
  e as default
};
